import request from "./request";
import apiList from "./apiList";
import {getCookie} from "../globalFunction";

let {IPV6_URL, BASEV3URL, TISUURL, BASEURL, NEW_TISU_FORGE_URL, NEW_TISU_V3_URL} = apiList
let api = {

    //数据埋点
    buriedPoint: (data) => {
        return request({
            url: BASEURL + '/v2/buried-point',
            method: "post",
            data
        })
    },

    //数据埋点v3
    buriedPointV3: (data) => {
        return request({
            url: `${BASEV3URL}/statistics`,
            method: 'get',
            data,
            reqType: 'ajax'
        })
    },

    // 小礼云登录
    integralLogin: () => {
        return request({
            url: BASEURL + '/v2/integral/login/free',
        })
    },


    //保存评分结果
    saveScore: (data) => {
        return request({
            url: `${BASEV3URL}/score/saveScore`,
            method: 'post',
            data,
            reqType: 'ajax'
        })
    },


    //获取宽带提速默认价格
    getSpeedUpDefaultPrice: (data = {}) => {
        return request({
            url: `${NEW_TISU_V3_URL}/speedUp/price`,
            method: 'get',
            data,
            reqType: 'ajax'
        })
    },

    //宽带提速生成助力链接
    jiasuBoostUrl: function (params) {
        if (params.type === 2) {
            return request({
                method: 'get',
                url: `${NEW_TISU_FORGE_URL}/v2/help-speed-up/link`,
                params,
                responseType: "blob",
            })
        } else {
            return request({
                method: 'get',
                url: `${NEW_TISU_FORGE_URL}/v2/help-speed-up/link`,
                params
            })
        }
    },


    //宽带提速生成助力链接
    jiasuMiniQR: function (params) {
        return request({
            method: 'get',
            params,
            url: `${NEW_TISU_FORGE_URL}/v2/help-speed-up/mini-app-qr`
        })
    }
    ,

    //宽带提速生成助力链接
    jiasuBoostUse: function (data) {
        return request({
            method: 'post',
            url: `${NEW_TISU_FORGE_URL}/v2/help-speed-up/subscribe_success`,
            data
        })
    },

    //宽带提速Ta助力
    jiasuBoostHelp: function (data) {
        return request({
            method: 'post',
            url: `${NEW_TISU_FORGE_URL}/v2/help-speed-up/add_help_info`,
            data
        })
    }
    ,

    //款待提速助力列表
    jiasuBoostList: function (data) {
        return request({
            method: 'post',
            url: `${NEW_TISU_FORGE_URL}/v2/help-speed-up/list`,
            data
        })
    },

    /**
     * 保存用户信息
     */
    saveProfile: (data) => {
        return request({
            method: 'post',
            url: `${BASEURL}/v2/user/profile`,
            data
        })
    },

    //保存提速插件
    saveTisuPlugin: (data) => {
        return request({
            method: 'post',
            url: `${BASEURL}/v2/enterprise/save-plugin`,
            data
        })
    },

    //判断是否可以申请提速插件
    checkTisuPlugin: (params) => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/enterprise/check-plugin`,
            params
        })
    },

    //获取账户收益
    myIncome: (params) => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/enterprise/my-income`,
            params
        })
    },

    //获取账户收益
    gainRemoveAdPrice: () => {
        return request({
            url: `${BASEV3URL}/userVipOrder/price`,
            method: 'get',
            reqType: 'ajax'
        })
    },

    //获取提速插件订单记录
    gainTisuPluginOrder: (params) => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/enterprise/plugin-order`,
            params
        })
    },

    //获取提速插件收支明细详情
    gainTisuPluginIncomDetail: (params) => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/enterprise/income-detail`,
            params
        })
    },

    //获取提速插件收支明细
    gainTisuPluginBalance: (params) => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/enterprise/pay-balance`,
            params
        })
    },

    //宽带提速插件提现
    saveTisuPluginWithdraw: (data) => {
        return request({
            method: 'post',
            url: `${BASEURL}/v2/enterprise/apply-withdraw`,
            data
        })
    },


    //优惠券列表(不需要登录)
    gainCouponList: async () => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/coupon/coupon-list`,
        })
    },

    //获取我的优惠券列表
    gainBonusCoupon: function (data) {
        return request({
            url: `${NEW_TISU_V3_URL}/userCoupon/my`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },

    //活动通过活动赠送的优惠券
    gainCouponIndex: function (data) {
        return request({
            url: `${BASEV3URL}/coupon/index`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },

    //宽带提速到期赠送优惠券操作
    renewCoupon: function (data) {
        return request({
            method: 'post',
            url: `${BASEV3URL}/userCoupon/renewalGet`,
            data,
            reqType: 'ajax'
        })
    },

    // 暑假活动券领取
    postSummerGet: function (data) {
        return request({
            method: 'post',
            url: `${BASEV3URL}/userCoupon/summerGet`,
            data,
            reqType: 'ajax'
        })
    },

    // 新人好礼活动券领取
    postNewGet: function (data) {
        return request({
            method: 'post',
            url: `${BASEV3URL}/userCoupon/newGet`,
            data,
            reqType: 'ajax'
        })
    },

    //优惠券列表(需要登录)
    gainMyCouponList: async () => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/coupon/my-coupon-list`
        })
    },


    //续费优惠券(需要登录)
    gainMyRenewalCoupon: function (params) {
        return request({
            method: 'GET',
            url: `${BASEURL}/v2/coupon/my-renewal-coupon`,
            params
        })
    }
    ,

    //领取续费优惠券
    saveRenewalCoupon: function (data) {
        return request({
            method: 'post',
            url: `${BASEURL}/v2/coupon/save-renewal-coupon`,
            data
        })
    }
    ,

    //618优惠券领取
    jiasuSaveCoupon: function (data) {
        return request({
            method: 'post',
            url: `${BASEURL}/v2/coupon/save-coupon`,
            data
        })
    },


    //获取主题背景(不需要登陆)
    activityIndexBg: function (params) {
        return request({
            method: 'GET',
            url: `${BASEURL}/v2/activity/activity-img`,
            params,
        })
    },


    //获取活动列表(www和m站使用)
    activityList: function () {
        return request({
            method: 'GET',
            url: `${BASEURL}/v2/activity/activity-list`
        })
    },
    //测速结束加测项目
    speedItem: function () {
        return request({
            url: `${BASEV3URL}/tool/website/getItemList?source=www`,
            method: 'get',
            reqType: 'ajax',
        })
    }
    ,


    // 获取app的版本号
    gainAppVersion: function (params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/app/version`,
            params,
        })
    }
    ,
    //获取app版本信息
    gainAppVersionV3: function (params) {
        return request({
            url: `${BASEV3URL}/app/downInfo`,
            method: 'get',
            params,
            reqType: 'ajax'
        })
    },

    //公告详情
    gainNoticeDetail: function (params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/notice/detail`,
            params,
        })
    },

    //获取首页5g视频
    getIndexFiveGVideo(params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/5g/video-page`,
            params,
        })
    },
    //问答分类
    gainFqaAskCate: function (params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/ask/ask-cate`,
            params,
        })
    }
    ,
    //问答标签
    gainFqaAskTag: function (params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/ask/ask-tag`,
            params,
        })
    }
    ,
    //问答列表
    gainFqaAskList: function (params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/ask/ask-list`,
            params,
        })
    }
    ,
    //问答详情
    gainFqaAskDetail: function (params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/ask/ask-detail`,
            params,
        })
    }
    ,
    //问答是否有用
    gainFqaAskUseful: function (data) {
        return request({
            method: 'post',
            url: `${BASEURL}/v2/ask/ask-useful`,
            data,
        })
    }
    ,
    //问答反馈
    gainFqaAskFeedback: function (data) {
        return request({
            method: 'post',
            url: `${BASEURL}/v2/ask/ask-feedback`,
            data,
        })
    }
    ,


    //定位数据上报
    locationStore: function (data) {
        return request({
            url: `${BASEV3URL}/location/store`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },
    //浏览器信息上报
    browserStore: function (data) {
        return request({
            url: `${BASEV3URL}/browser/store`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },
    // 设备信息上报
    deviceStore: function (data) {
        return request({
            url: `${BASEV3URL}/device/store`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },
    telemetry: function (data) {
        return request({
            url: `${BASEV3URL}/speed/store`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },
    //获取打分类型
    getScoreType: function (data) {
        return request({
            url: `${BASEV3URL}/score/scoreType`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //上报加测数据
    toolDataStore: function (data) {
        data.timestamp = Date.now();
        return request({
            url: `${BASEV3URL}/toolData/store`,
            method: 'post',
            reqType: 'ajax',
            data,
        })

    },
    resultSetUser: function (data) {
        return request({
            url: `${BASEV3URL}/speed/bind`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },

    //加入我们-获取团队氛围
    gainAboutUs: function (data) {
        return request({
            url: `${BASEV3URL}/aboutUs`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //加入我们-获取职位
    gainJob: function (data) {
        return request({
            url: `${BASEV3URL}/job`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //获取用户信息
    gainUserInfoV3: function (data) {
        return request({
            url: `${BASEV3URL}/user/info?t=${new Date().getTime()}`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //www端首页的文章
    articlesWebIndex: function (params) {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/articles/web-index`,
            params,
        })
    },

    // 获取业务测试的列表
    getWebsiteList: (data) => {
        return request({
            url: `${BASEV3URL}/tool/website/getWebsiteWeb`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //南京移动判断7天是否弹窗
    getSpeedInfo: (data) => {
        return request({
            url: `${BASEV3URL}/speedInfoV2/getSpeedInfo`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //滁州联通判断七天是否有弹窗
    getSpeedInfoChuZhou: (data) => {
        return request({
            url: `${BASEV3URL}/speedInfoV2/chuzhou`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //南京移动获取最新的签约宽带信息
    getSignBrand: (data) => {
        return request({
            url: `${BASEV3URL}/speedInfo/getSignBrand`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //南京移动用户反馈上报
    saveSpeedInfo: (data) => {
        return request({
            url: `${BASEV3URL}/speedInfo/saveSpeedInfo`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },

    saveSpeedInfoV2: (data) => {
        return request({
            url: `${BASEV3URL}/speedInfoV2/saveFeedback`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },

    // 南京用户签约带宽
    postSaveSignBrand: (data) => {
        return request({
            url: `${BASEV3URL}/speedInfoV2/saveSignBrand`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },


    getBanner: () => {
        return request({
            url: `${NEW_TISU_V3_URL}/speedUp/getBanner`,
            method: 'get',
            reqType: 'ajax',
        })
    },

    /**
     * 获取测速详情
     * */
    getSpeedDetail: (data) => {
        return request({
            url: `${BASEV3URL}/speed/detail`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },

    /**
     * 获取测速详情的加测项
     * */
    getSpeedToolData: (data) => {
        return request({
            url: `${BASEV3URL}/toolData/getList`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    getCMCCSmsCode: (data) => {
        return request({
            url: `${BASEV3URL}/Cmcc/getSmsCode`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },
    CMCCOrder: (data) => {
        return request({
            url: `${BASEV3URL}/Cmcc/order`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },
    CMCCValid: (data) => {
        return request({
            url: `${BASEV3URL}/Cmcc/valid`,
            method: 'post',
            reqType: 'ajax',
            data
        })
    },

    /**
     * 获取个人信息收集清单（主app用）
     * */
    getPrivacyPolicy: (data) => {
        return request({
            url: `${BASEV3URL}/privacyPolicy/index`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    /**
     * 获取测速限制城市
     * */
    getCheckDistrict: (data) => {
        return request({
            url: `${BASEV3URL}/speed/checkDistrict`,
            method: 'get',
            reqType: 'ajax',
            data,
            headers: {
                'CLIENTECTYPE': 66,
            },
            hasAesDecipher: true
        })
    },

    /**
     * 获取导航栏小图标
     * */
    getLabel: () => {
        return request({
            url: `${BASEV3URL}/home/getLabel`,
            method: 'get',
            reqType: 'ajax',
        })
    },

    /**
     * 获取附近用户的测速记录
     * */
    getNeighbors: () => {
        return request({
            url: `${BASEV3URL}/speed/neighbors`,
            method: 'get',
            reqType: 'ajax',
        })
    },

    /**
     * 获取广告详情
     * */
    getAd: (params) => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/show`,
            params
        })
    },

    /**
     * 获取广告详情(八个广告位使用)
     * */
    getAdNew: (params) => {
        return request({
            method: 'get',
            url: `${BASEURL}/v2/show/index_new`,
            params
        })
    },

    /**
     * 获取ipv6信息
     * */
    getIpV6: (data) => {
        return request({
            url: `${IPV6_URL}/ip`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    /**
     * 路由器重拨
     * **/
    gainUpReopen: () => {
        return request({
            url: apiList.speedupReOpenUrl,
            method: 'get'
        })
    },
    gainUpOpen: (data) => {
        return request({
            url: apiList.speedupOpenUrl,
            method: 'post',
            data
        })
    },
    // 获取验证码
    gainSmsVerifyCode: (data) => {
        return request({
            url: apiList.smsVerifyCode,
            method: 'post',
            data,
            reqType: 'ajax',
        })
    },
    // 校验验证码是否正确
    postSmsVerify: (data) => {
        return request({
            method: 'post',
            data,
            url: apiList.smsVerify,
        })
    },
    postModifyPhone: (data) => {
        return request({
            method: 'post',
            data,
            url: apiList.modifyPhone,
        })
    },
    getAdUrl: () => {
        return request({
            method: 'get',
            url: apiList.adUrl + '&position=speed_end_alter',
        })
    },
    postBuriedPointUrl: (data) => {
        return request({
            method: 'post',
            url: apiList.buriedPointUrl,
            data
        })
    },
    // 手机号登录
    getCrossLogin: (params) => {
        return request({
            method: 'get',
            url: apiList.crossLoginUrl,
            params
        })
    },
    // 账号登录
    getAccountLogin: (params) => {
        return request({
            method: 'get',
            url: apiList.accountLoginUrl,
            params
        })
    },
    // 手机号归属地
    getLocationPhoneUrl: (params) => {
        return request({
            method: 'get',
            url: apiList.locationPhoneUrl,
            params
        })
    },
    // 获取5g手机排行榜
    queryPhoneList: (params) => {
        return request({
            method: 'get',
            url: apiList.fiveGPhoneList,
            params
        })
    },
    // 获取运营商数据
    getHallRequest: (params) => {
        return request({
            method: 'get',
            url: apiList.hallUrl,
            params
        })
    },
    // 获取5g排名
    get5gRankOperatorRequest: (params) => {
        return request({
            method: 'get',
            url: apiList.get5gRankOperator,
            params
        })
    },

    //获取tv下载
    queryAppVersion: (params) => {
        return request({
            method: 'get',
            url: apiList.appVersionUrl,
            params
        })
    },
    //保存打分数据
    postScoreData: (data) => {
        return request({
            method: 'post',
            url: BASEURL + '/result/' + data.hashId + '/score/' + (data.index),
        })
    },
    //查询宽带状态
    getSpeedupQuery: (params) => {
        return request({
            method: 'get',
            url: apiList.speedupQueryV3Url,
            params,
            reqType: 'ajax'
        })
    },
    getNodesList: (params) => {
        return request({
            method: 'get',
            url: apiList.NODES_URL,
            params,
            reqType: 'ajax',
            noWithCredentials: true
        })
    },

    postBindPhone: (data) => {
        return request({
            method: 'post',
            url: apiList.bindPhone,
            data,
            reqType: 'ajax',
        })
    },
    getCheckPhoneBinding: (params) => {
        return request({
            method: 'get',
            url: apiList.checkPhoneBinding,
            params,
            // hasAesDecipher: true,
        })
    },
    getLatestUrl: (params) => {
        return request({
            method: 'get',
            url: apiList.latestUrl,
            params,
            reqType: 'ajax',
        })
    },
    queryDivisionLink: (params, responseType = "") => {
        return request({
            method: 'get',
            url: apiList.divisionLinkUrl,
            params,
            responseType: responseType,
        })
    },
    queryBalenceListV2: (params) => {
        return request({
            method: 'get',
            url: apiList.balanceListV2Url,
            params,
        })
    },
    queryDivisionList: (params) => {
        return request({
            method: 'get',
            url: apiList.divisionListUrl,
            params,
        })
    },
    postAdfreeSubScribe: (data) => {
        return request({
            method: 'post',
            url: apiList.adfreeSubScribeUrl,
            data,
            reqType: 'ajax',
            headers: {
                Accept: "application/json"
            }
        })
    },
    postSpeedupPay: (data) => {
        return request({
            method: 'post',
            url: apiList.speedupPayUrl,
            data,
            reqType: 'ajax',
            headers: {
                Accept: "application/json"
            }
        })
    },
    getPayStatus: (params) => {
        return request({
            method: 'get',
            url: apiList.payStatusUrl,
            params,
            reqType: 'ajax',
            headers: {
                Accept: "application/json"
            }
        })
    },
    getSpeedupRecord: (params) => {
        return request({
            method: 'get',
            url: apiList.speedupRecordUrl,
            params,
            reqType: 'ajax',
            noWithCredentials: true
        })
    },
    postSpeedupSubScribe: (data) => {
        return request({
            method: 'post',
            url: apiList.speedupSubScribeUrl,
            data,
            reqType: 'ajax',
            headers: {
                Accept: "application/json"
            }
        })
    },
    postCMCCPackages: (data) => {
        return request({
            method: 'post',
            url: apiList.getCMCCPackages,
            data,
            reqType: 'ajax',
        })
    },
    getEmotionsJson: (params) => {
        return request({
            method: 'get',
            url: apiList.emotionsJsonUrl,
            params,
            reqType: 'ajax',
            dataType: 'jsonp',
        })
    },
    getLocationInfo: (params) => {
        return request({
            method: 'get',
            url: apiList.locationInfo,
            params,
            reqType: 'ajax',
            headers: {
                'CLIENTECTYPE': 65,
            },
            hasAesDecipher: true,
            noWithCredentials: true
        })
    },

    // 进行退出
    getLogout: () => {
        return request({
            method: 'get',
            url: apiList.logoutUrl,
        })
    },

    // 获取附近网速
    getNearbySpeed: (params) => {
        return request({
            method: 'get',
            url: apiList.nearbySpeedUrl,
            params,
            reqType: 'ajax',
            noWithCredentials: true
        })
    },

    // 获取app下载
    getAppVersionLatest: (params) => {
        return request({
            method: 'get',
            url: apiList.appVersionLatestUrl,
            params,
        })
    },

    // 获取app拆分数据
    getAppVersionAppList: (params) => {
        return request({
            method: 'get',
            url: apiList.appVersionAppListUrl,
            params,
        })
    },
    // 获取测速咨询
    getArticles: (params) => {
        return request({
            method: 'get',
            url: apiList.articlesUrl,
            params
        })
    },

    // 获取小程序排行榜的收益
    getGroupBalanceUrl: () => {
        return request({
            method: 'get',
            url: apiList.groupBalanceUrl,
            reqType: 'ajax',
        })
    },

    // 获取微信的makeUrl
    getWechatMakeUrl: (productId) => {
        return request({
            method: 'get',
            url: `${apiList.wechatMakeUrl}?type=7&about_id=${productId}`,
        })
    },

    //保存滁州联通信息
    saveChuZhouInfo: (data) => {
        return request({
            method: 'post',
            url: BASEV3URL + '/speedInfoV2/saveChuzhou',
            data
        })
    },

    //测速前后活动弹窗封装
    getActiveLists: (data) => {
        return request({
            url: `${BASEV3URL}/activity/activityList`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },

    //活动详情
    getActiveDetail: (data) => {
        return request({
            url: `${BASEV3URL}/activity/activityDetail`,
            method: 'get',
            reqType: 'ajax',
            data
        })
    },
    //保存滁州联通信息
    getGeneralContent: (data) => {
        return request({
            method: 'get',
            url: apiList.policyInfoUrl,
            data
        })
    },
    //获取首页的5G视频数据信息
    getIndex5gVideosUrl() {
        return request({
            method: 'get',
            url: apiList.index5gVideosUrl,
        })
    },
    //获取首页的5G视频数据信息
    getIndexSponsorUrl() {
        return request({
            method: 'get',
            url: apiList.indexSponsorUrl,
        })
    },

    //新的节点获取接口
    getNewNodesList: (params) => {
        return request({
            method: 'get',
            url: apiList.NEW_NODES_URL,
            params,
            withCredentials: false
        })
    },
    //提速宣传视频
    getTisuVideo: () => {
        return request({
            method: 'get',
            url: `${BASEV3URL}/speedUp/speepupVideo`,
        })
    },
    //问卷送优惠券
    postSurveyStore: (data) => {
        return request({
            method: 'post',
            url: `${BASEV3URL}/speedUp/surveyStore`,
            data,
        })
    },

    // 获取oss的私有地址
    getPrivateOss: (data) => {
        return request({
            method: 'get',
            url: apiList.privateOssUrl,
            data,
        })
    },

    // 请求file内容
    getFileContent: (reqUrl) => {
        return request({
            method: 'get',
            url: reqUrl,
            withCredentials: false,
            hasAesDecipher: true,
        })
    },
    //提速宣传视频
    getIndexPing: (params) => {
        return request({
            method: 'get',
            params,
            url: `${BASEV3URL}/tool/website/faultWebsiteWeb`,
            hasAesDecipher: true,
        })
    },
    // Pk小程序排行榜
    getPkWebsiteList: (params) => {
        return request({
            method: 'get',
            params,
            url: `https://speedtest-community-test.speedtest.cn/ranks/list`,
            hasAesDecipher: true,
        })
    },
    //视频测试数据上报
    postVideoStore: (data, isLogin) => {
        return request({
            method: 'post',
            data,
            url: isLogin ? apiList.videoMyStoreUrl : apiList.videoStoreUrl,
        })
    },
    postVideoSetUser: (data) => {
        return request({
            method: 'post',
            data,
            url: apiList.videoSetUserUrl,
        })
    },
    getVideoMySpeed: (params) => {
        return request({
            method: 'get',
            params,
            url: apiList.videoMySpeedUrl,
        })
    },
    getVideoMyDel: (data) => {
        return request({
            method: 'get',
            data,
            url: apiList.videoMyDelUrl,
        })
    },
    //满意度排行
    postIspSatisfaction: (data) => {
        return request({
            method: 'post',
            url: apiList.ispSatisfactionUrl,
            data,
        })
    },

    //注销申请
    postLogoutApply: (data) => {
        return request({
            method: 'post',
            url: apiList.LogoutApplyUrl,
            data
        });
    },

    // 注销进度查询
    getLogoutProgress: (data) => {
        return request({
            method: 'get',
            url: apiList.LogoutProgressUrl,
            data
        });
    },


    // 注销申请账号恢复
    getLogoutRecover: (data) => {
        return request({
            method: 'get',
            url: apiList.LogoutRecoverUrl,
            data
        });
    }

};
window.api = api

export default api;




// WEBPACK FOOTER //
// ./resources/js/config/api.js